import React from 'react';
import { validationStrings } from '/imports/strings';

interface FormErrorProps {
  field: string,
  error?: any
}

export const FormError = (props: FormErrorProps) => {
  const { field, error } = props;
  const errorString = (validationStrings as any)[error?.[field]?.[0]]?.() || error?.[field]?.[0];
  if (!errorString) return null;
  return (
    <div className="error border-l-[3px] border-red-2 px-2 py-0 text-red-2">
      {errorString}
    </div>
  );
};
